import type { AddressForm } from '@/shared/utils/areaPicker/types';

export interface UserAdditionalInfoType extends Record<
  string, string|number|boolean|AddressForm|undefined
>{
  maritalStatus: number | undefined,
  liveStatus: number | undefined,
  commonEmail: string | undefined,
  profession: number | undefined,
  position: number | undefined,
  role: number | undefined,
  industry: number | undefined,
  companyName: string | undefined,
  companyNature: number | undefined,
  companyAddress: AddressForm | undefined,
  companyAddressDetails: string | undefined,
  companyPhone: string | undefined,
  debtSituation: number | undefined,
  sourceOfIncome: number | undefined,
  id?: string,
}

/** 婚姻状况 */
export enum MaritalStatusEnum {
  /** 未婚  */
  UNMARRIED = 1,
  /** 已婚 */
  MARRIED = 2,
  /** 离异 */
  DIVORCED = 3,
  /** 其他 */
  OTHER = 4,
}

/** 更新zyq信息来源 */
export enum UpdateZyqSourceEnum {
  /** 我的 */
  MINE_PAGE = 1,
  /** 首页(授信、用信流程) */
  HOME_PAGE = 2,
}

/** 更新zyq信息场景(服务端定义：罗肖) */
export enum UpdateZyqSceneEnum {
  /** 个人信息 */
  BASE_INFO = 0,
  /** 紧急联系人 */
  ONLY_CONTACTS = 1,
}

export interface MaritalStatusCheckContact {
  /**
   * 是否需要填写配偶信息  true需要，false不需要
   */
  emergencyCheck?: boolean;
  /**
   * 联系人信息是否需要锁定配偶(锁定关系)  true需要，false不需要
   */
  lockEmergency?: boolean;
  /**
   * 非已婚关系是否需要置灰配偶关系, 联系人关系 不让选择「配偶」项  true需要，false不需要
   */
  unMarriedCheck?: boolean;
  /**
   * 非已婚关系是否需要置灰配偶关系(锁定关系)  true需要，false不需要
   */
  lockUnMarried?: boolean;
  /**
   * 风控补件场景是否需要展示联系人信息  true需要，false不需要
   */
  riskRequireContactsCheck?: boolean;
}
